import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuUserX, LuChevronDown, LuChevronRight, LuArchiveRestore } from 'react-icons/lu';
import api from '../../services/api';

// Clientes dados de baja (Portal Empresa, 14-oct-2026): no se borran; vuelven con sus equipos e historial.
export default function ClientesDeBaja({ onCambio }) {
    const [bajas, setBajas] = useState([]);
    const [ver, setVer] = useState(false);
    const cargar = () => api.get('/empresa/clientes/bajas').then(r => setBajas(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    useEffect(() => { cargar(); }, []);
    const restaurar = async (c) => {
        try { await api.patch(`/empresa/clientes/${c.id}/restaurar`); toast.success(`${c.nombre} restaurado`); cargar(); onCambio && onCambio(); }
        catch (err) { toast.error(err?.response?.data?.mensaje || 'No se pudo restaurar'); }
    };
    if (!bajas.length) return null;
    return (
        <section className="rounded-2xl border border-dashed border-black/[0.12] dark:border-white/[0.12] overflow-hidden">
            <button type="button" onClick={() => setVer(v => !v)} className="w-full flex items-center gap-2 px-4 py-3 text-left">
                <LuUserX size={15} className="shrink-0 text-muted" />
                <span className="flex-1 text-caption font-black text-secondary">Clientes dados de baja · {bajas.length}</span>
                {ver ? <LuChevronDown size={18} className="text-muted" /> : <LuChevronRight size={18} className="text-muted" />}
            </button>
            {ver && bajas.map(c => (
                <div key={c.id} className="flex items-center gap-3 px-4 py-2.5 border-t border-black/[0.05] dark:border-white/[0.05]">
                    <span className="flex-1 min-w-0">
                        <span className="block text-body font-bold text-secondary truncate">{c.nombre}</span>
                        <span className="block text-caption text-muted truncate">{c.direccion}{c.equipos ? ` · ${c.equipos} eq.` : ''}</span>
                    </span>
                    <button type="button" onClick={() => restaurar(c)}
                        className="shrink-0 h-9 px-3 rounded-xl bg-chip text-label font-black text-ink inline-flex items-center gap-1.5 active:scale-95"><LuArchiveRestore size={14} /> Restaurar</button>
                </div>
            ))}
        </section>
    );
}
